//  import { Container } from 'react-bootstrap'
 import React from 'react'
//  import { useState,useEffect } from 'react'
//  import axios  from 'axios'
//  import { useNavigate } from 'react-router-dom'
 import about from './imeges/About1.jpg'
import { useTheme } from './ThemeContext';
 
 const About = () => {
  // const navigate = useNavigate()
  // const [images, setImages] = useState([]); // Store images
  // const [loading, setLoading] = useState(true); // Loading state
  // const [error, setError] = useState(null); // Error state


  // useEffect(() => {
  //   const fetchImages = async () => {
  //     try {
  //       const response = await axios.get("http://localhost:5000/api/img/images/about"); // Fetch from backend
  //       setImages(response.data);
  //     } catch (error) {
  //       console.error("Error fetching images:", error);
  //     } 
  //   };

  //   fetchImages();
  // }, []);

  // // 🔥 Fetch specific images by name
  // const getImageUrl = (imageName,locaIamge) => {
  //   if (!images || images.length === 0) return locaIamge; // Return placeholder if not found
  //   const image = images.find((img) => img.original_name === imageName);
  //   return image ? image.url : locaIamge; // Default placeholder image
  // };

  // if (loading) return <p>Loading images...</p>;
  // if (error) return <p>{error}</p>;
  const routeChange = (section) => {
    // navigate("/");

    setTimeout(() => {

      window.location.href = `/#${section}`;
    }, 100);
  };
    const {theme} = useTheme();
  
   return (
   <>

  
    <section id="about" className=" text-left" style={{ backgroundColor: '',  }}>

      <h2 className='m-5 text-center' style={{fontWeight:'bold', }} >About Us</h2>
      
        <div className='row m-5'>
          <div className='col-md-6  '>
            <img 
            // src={getImageUrl("about",about)} 
            src={about}
            loading='lazy'
            alt="About section " 
            className='img-fluid'
              height={350}
              width={700}
              style={{ backgroundColor: '#343a40',marginBottom:'20px',backgroundSize:'cover', maxHeight:'350px' }} 
            />
          </div>
          <div className='col-md-6'>
            <p style={{ fontFamily: 'Arial, sans-serif', fontSize: '16px', lineHeight: '1.6', margin:'10 30'}}>
              We at Bot Bridge Technologies deliver Digital Transformation  to all Diagnostic Laboratories, Hospital attached Labs, Hospitals & Clinics.  With <span className='fw-bold fs-5'style={{  color: theme === 'dark' ? '#66B2FF' : '#001351', fontFamily: 'Playfair Display, serif', // Correct the font-family syntax
}}>cutting edge technologies and AI driven analysis</span> we enable our customers to focus on patient service and provide clinically accurate reports, each time & every time,  thereby improving better treatment outcome.
            </p>
            <button className="btn btn-primary m-2 " style={{ color: 'white',
            backgroundColor:"#001351"}} onClick={ ()=>routeChange('contact')}>
              Contact Us
            </button>
          </div>
        </div>
      
    </section>
    </>
   )
 }
 
 export default About


